import { createContext, useContext } from 'react';
import { ApiState } from '@paradigm/api/src/fetch-api';
import { LegTableView } from '#/unified-rfqs/ui/types';
import { GetTradeDetailsResp } from '#/unified-rfqs/repositories/grfq-types';
import legsView from './details-view/legs';
import { errorMessageView } from './details-view/errorMessage';
import { sideView } from './details-view/side';

export interface ViewState {
  readonly legs: LegTableView[];
  readonly isLoading: boolean;
  readonly errorMessage: string;
  /** side is null if the user didn't participate on the trade */
  readonly side: 'BUY' | 'SELL' | null;
}

export const ViewCtx = createContext<ViewState | null>(null);

ViewCtx.displayName = 'TradeDetailsView';

export function useTradeDetailsView() {
  const ctx = useContext(ViewCtx);
  if (ctx !== null) return ctx;
  throw new Error('Missing TradeDetailsProvider upwards in this tree.');
}

interface CreateViewArgs {
  readonly tradeFetch: ApiState<GetTradeDetailsResp>;
}

export function createView({ tradeFetch }: CreateViewArgs): ViewState {
  const legs = legsView(
    tradeFetch.resp?.ok === true ? tradeFetch.resp.data.legs : [],
  );
  const side = sideView(tradeFetch.resp);
  const errorMessage = errorMessageView(tradeFetch.resp);
  const { isLoading } = tradeFetch;
  return {
    isLoading,
    errorMessage,
    side,
    legs,
  };
}
